export enum Role {
  ADMIN = 'ADMIN',
  DIRECCION = 'DIRECCION',
  SUBDIRECCION = 'SUBDIRECCION',
  GERENTE = 'GERENTE',
}
